import { takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionType as financialModelActionType } from "./reducer";

import { getFinancialModel as getFinancialModelService } from "./service";

function* getFinancialModel({ id, params }) {
  yield processAction({
    params: { id, params },
    service: getFinancialModelService,
    success: financialModelActionType.GET_FINANCIAL_MODEL_SUCCESS,
    failed: financialModelActionType.GET_FINANCIAL_MODEL_FAILED
  });
}

function* watchgetFinancialModel() {
  yield takeLatest(
    financialModelActionType.GET_FINANCIAL_MODEL,
    getFinancialModel
  );
}

export default [watchgetFinancialModel()];



// WEBPACK FOOTER //
// ./src/modules/company/pages/financial-model/saga.js